const getBannerLinks = route => {
  const splittedRoute = route.split("/");
  const refCode = splittedRoute[2];
  return (
    (route.startsWith("/invite/") &&
      `https://app.adjust.com/qr9fanx?deep_link=locale%3A%2F%2F%3Fuser_ref%3D${refCode}`) ||
    "https://app.adjust.com/qr9fanx"
  );
};
export default getBannerLinks;
